var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitCardFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "307px",
    height: "300px",
    viewBox: "0 0 307 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1.0-Injury_-Personal-questions(Step-1)-1280",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-182.000000, -153.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(182.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 47.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "field",
    stroke: "#C2C3C9",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 0.5,
    y: 14.5,
    width: 294,
    height: 173,
    rx: 16
  }), /*#__PURE__*/React.createElement("text", {
    id: 12345,
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 500,
    fill: "#5E6073"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    y: 127
  }, "0012345")), /*#__PURE__*/React.createElement("text", {
    id: 1,
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 500,
    fill: "#5E6073"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 142,
    y: 127
  }, "000000001")), /*#__PURE__*/React.createElement("text", {
    id: "Contrat",
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 12,
    fontWeight: 500,
    fill: "#8E90A2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 33,
    y: 101
  }, "Contrat")), /*#__PURE__*/React.createElement("text", {
    id: "Certificat-du-partic",
    fontFamily: "ManulifeJHSans-Demibold, Manulife JH Sans",
    fontSize: 12,
    fontWeight: 500,
    fill: "#8E90A2"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 142,
    y: 101
  }, "Certificat du participant")), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: 204,
    x2: 65,
    y2: 141,
    id: "Line",
    stroke: "#00A758",
    strokeWidth: 2,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195,
    y1: 83,
    x2: 195,
    y2: 1,
    id: "Line",
    stroke: "#00A758",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Num\\xE9ro-de-certificat",
    fontFamily: "ManulifeJHSans-Regular, Manulife JH Sans",
    fontSize: 16,
    fontWeight: "normal",
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 132,
    y: 16
  }, "Num\xE9ro de certificat")), /*#__PURE__*/React.createElement("text", {
    id: "Num\\xE9ro-de-contrat-ou",
    fontFamily: "ManulifeJHSans-Regular, Manulife JH Sans",
    fontSize: 16,
    fontWeight: "normal",
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 279
  }, "Num\xE9ro de contrat ou num\xE9ro de police")), /*#__PURE__*/React.createElement("text", {
    id: "9-chiffres",
    fontFamily: "ManulifeJHSans-Light, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 300,
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 132,
    y: 39
  }, "9 chiffres")), /*#__PURE__*/React.createElement("text", {
    id: "7-chiffres",
    fontFamily: "ManulifeJHSans-Light, Manulife JH Sans",
    fontSize: 16,
    fontWeight: 300,
    fill: "#34384B"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 26,
    y: 302
  }, "7 chiffres")))))), /*#__PURE__*/React.createElement("g", {
    id: "Foundations/Logos/Manulife/Logo-Primary-FR",
    transform: "translate(33.000000, 85.653846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A758",
    fillRule: "nonzero",
    points: "14.1661538 3.70461538 14.1661538 19.4030769 17.6553846 15.9138462 17.6553846 0.215384615"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A758",
    fillRule: "nonzero",
    points: "7.19384615 19.4030769 10.6769231 15.9138462 10.6769231 0.215384615 7.19384615 3.70461538"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#00A758",
    fillRule: "nonzero",
    points: "0.215384615 19.4030769 3.70461538 15.9138462 3.70461538 0.215384615 0.215384615 3.70461538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3938462,16.7876923 L56.3938462,15.6492308 C55.6826551,16.539049 54.5972978,17.0464592 53.4584615,17.0215385 C51.6923077,17.0215385 50.2338462,15.9015385 50.2338462,13.9938462 C50.2338462,11.6676923 52.4123077,10.8246154 54.5415385,10.5907692 L55.3723077,10.4984615 C56.1846154,10.4246154 56.4738462,9.97538462 56.4738462,9.43384615 C56.4738462,8.76923077 55.8584615,8.28307692 54.8861538,8.28307692 C53.8532378,8.33323335 52.901482,8.85794833 52.3076923,9.70461538 L51.0769231,8.20923077 C52.0463788,7.05675148 53.4989219,6.42382516 55.0030769,6.49846154 C57.3107692,6.49846154 58.64,7.68615385 58.64,9.66769231 L58.64,16.7876923 L56.3938462,16.7876923 Z M56.3938462,11.9753846 L54.88,12.1538462 C53.5630769,12.3138462 52.4184615,12.7692308 52.4184615,13.9015385 C52.4381421,14.2910908 52.6177083,14.6552546 52.9147583,14.9080383 C53.2118083,15.1608221 53.6000088,15.2798165 53.9876923,15.2369231 C54.9734343,15.1750041 55.8782792,14.6705531 56.4492308,13.8646154 L56.4492308,11.9753846 L56.3938462,11.9753846 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8246154,16.7876923 L60.6092308,16.7876923 L60.6092308,6.73230769 L62.8246154,6.73230769 L62.8246154,7.87076923 C63.7155596,7.03102483 64.8811222,6.54336917 66.1046154,6.49846154 C67.2923077,6.49846154 68.9169231,7.18153846 68.9169231,9.63076923 L68.9169231,16.7876923 L66.7015385,16.7876923 L66.7015385,10.2092308 C66.7015385,9.21846154 66.2892308,8.36307692 65.2615385,8.36307692 C64.3353794,8.4863949 63.4728919,8.90254514 62.8,9.55076923 L62.8246154,16.7876923 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7138462,6.73230769 L78.9292308,6.73230769 L78.9292308,16.7876923 L76.64,16.7876923 L76.64,15.7046154 C75.8774563,16.4976019 74.8404096,16.9687867 73.7415385,17.0215385 C72.4430769,17.0215385 70.6646154,16.3384615 70.6646154,13.8153846 L70.6646154,6.73230769 L72.88,6.73230769 L72.88,13.0892308 C72.88,14.2584615 73.3846154,15.0707692 74.4307692,15.0707692 C75.3369444,14.9967542 76.1721716,14.5512997 76.7384615,13.84 L76.7138462,6.73230769 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.1353846,2.20923077 C92.9061251,2.21917704 93.5285153,2.84156718 93.5384615,3.61230769 C93.5434374,4.18698693 93.2004273,4.70762513 92.6704301,4.92985011 C92.1404329,5.15207508 91.5286767,5.03176521 91.1223019,4.62539039 C90.7159271,4.21901557 90.5956172,3.60725942 90.8178422,3.07726221 C91.0400672,2.54726499 91.5607054,2.20425491 92.1353846,2.20923077 L92.1353846,2.20923077 Z M93.2861538,16.7876923 L90.9784615,16.7876923 L90.9784615,6.73230769 L93.2861538,6.73230769 L93.2861538,16.7876923 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1323077,12.3507692 C97.1006629,13.0590915 97.353281,13.7507071 97.8340091,14.271881 C98.3147373,14.793055 98.9837395,15.1006 99.6923077,15.1261538 C100.764694,15.0823115 101.742024,14.4986927 102.289231,13.5753846 L103.673846,14.8738462 C102.7025,16.2232201 101.13954,17.0207424 99.4769231,17.0154114 C96.6092308,17.0154114 94.8307692,14.8553846 94.8307692,11.7538462 C94.8307692,8.76307692 96.7569231,6.49230769 99.5507692,6.49230769 C102.215385,6.49230769 104.092308,8.24 103.981538,12.3507692 L97.1323077,12.3507692 Z M101.673846,10.6584615 C101.721241,10.0586001 101.521209,9.46545686 101.120216,9.01680947 C100.719223,8.56816208 100.152168,8.30305809 99.5507692,8.28307692 C98.2858007,8.36947422 97.2873047,9.39180709 97.2307692,10.6584615 L101.673846,10.6584615 Z",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillRule: "nonzero",
    points: "37.5384615 16.7876923 35.0769231 16.7876923 35.0769231 2.83076923 37.6923077 2.83076923 41.8461538 9.69230769 41.8461538 9.69230769 45.9384615 2.82461538 48.4984615 2.82461538 48.4984615 16.7876923 46.0369231 16.7876923 46.0369231 6.90461538 46 6.90461538 41.8030769 13.9323077 37.5384615 6.90461538 37.5384615 6.90461538"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000000",
    fillRule: "nonzero",
    points: "85.0461538 14.3507692 87.5076923 6.72615385 89.8461538 6.72615385 86.2953846 16.7815385 83.6923077 16.7815385 80.0492308 6.72615385 82.5107692 6.72615385 84.9723077 14.3507692"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitCardFr);
export default __webpack_public_path__ + "static/media/benefitCardFR.2e520cb05ffa98f36866849d48b9ae82.svg";
export { ForwardRef as ReactComponent };